import MainCourses from "../components/courses/MainCourses";

function Course() {
    return (
			<MainCourses/>
		);
}

export default Course;